import {SET_RECOMMENDATIONS, SET_RECOMMENDATION_UPDATE, SET_FEEDBACK_OPTED_OUT, SET_RECOMMENDATION_FEEDBACK} from './actions';

export const INITIAL_STATE = {
  recommendations: [],
  feedbackOptedOut: null
};

export default (recommendations = [], action) => {
  switch (action.type) {
    case SET_RECOMMENDATIONS:
      return [
        ...action.payload
      ];
    case SET_RECOMMENDATION_UPDATE: {
      const { declaration_id, reason, dismissed_user, dismissed_time } = action.payload;
      const rec = recommendations.find(recommendation => recommendation.declaration_id === declaration_id)
      if (rec) {
        rec.recommendation_status = action.payload.action === 'dismiss' ? 2 : 0;
        rec.dismissed_reason = reason;
        rec.dismissed_time = dismissed_time;
        rec.dismissed_user_name = dismissed_user;
      }
      return recommendations;
    }
    case SET_RECOMMENDATION_FEEDBACK: {
      const { declaration_id, up, down, my_rating } = action.payload;
      const rec = recommendations.find(recommendation => recommendation.declaration_id === declaration_id)
      if (rec) {
        rec.feedback = { up, down, my_rating };
      }
      return recommendations;
    }
    default:
      return recommendations;
  }
};

export const feedbackOptedOutReducer = (feedbackOptedOut = null, action) => {
  switch (action.type) {
    case SET_FEEDBACK_OPTED_OUT:
      return action.payload;
    default:
      return feedbackOptedOut;
  }
};
